import useBrazilianRealEstateFundIssuer from "components/company/v3/context/hooks/useBrazilianRealEstateFundIssuer";
import FundamenteiMetadata from "components/seo/FundamenteiMetadata";
import getBaseUrl from "lib/utils/getBaseUrl";
import { useIntl } from "react-intl";

interface FiiIssuerSeoProps {
  title?: string;
}
export default function FiiIssuerSeo({ title }: FiiIssuerSeoProps) {
  const intl = useIntl();
  const issuer = useBrazilianRealEstateFundIssuer();

  const primaryTickerSymbol = issuer.tickerSymbol;
  const pageTitle = title
    ? `${primaryTickerSymbol} - ${issuer.name} | ${title} | Fundamentei`
    : `${primaryTickerSymbol} - ${issuer.name} | Fundamentei`;
  const description = intl.formatMessage(
    {
      defaultMessage:
        "{primaryTickerSymbol} - {name}: Análise Fundamentalista, Balanços atualizados e histórico, Cotação, Rendimentos e muito mais!",
      id: "5nddnz",
    },
    {
      primaryTickerSymbol,
      name: issuer.name,
    },
  );
  const gitShaShort = process.env.GIT_SHA_SHORT || "1";
  const languageCode = intl.locale === "pt-BR" ? "pt-BR" : "en-US";
  const imageUrl = `${getBaseUrl()}/og/issuer/${primaryTickerSymbol.toLowerCase()}?locale=${languageCode}&ns=br&v=${gitShaShort}`;

  return (
    <FundamenteiMetadata
      title={pageTitle}
      description={description}
      openGraph={{
        images: [
          {
            url: imageUrl,
            width: 1200,
            height: 630,
            alt: `${primaryTickerSymbol} - ${issuer.name}`,
          },
        ],
      }}
    />
  );
}
